import {Component, input, output, computed, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvitationUploadDocumentResponse} from '@frontend/shared-api';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {
  DirectusTranslation,
  DirectusService,
  InvitationUploadDocumentTranslation,
} from '@frontend/directus';
import {toSignal} from '@angular/core/rxjs-interop';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppDatePipe, AppNumberPipe} from '@frontend/shared';
import {ConfirmationDialogService} from '../../../../../../../../shared/components/dialog/confirmation/confirmation-dialog.service';

@Component({
  selector: 'app-document-item',
  imports: [
    AppNumberPipe,
    CommonModule,
    TranslateDirectusPipe,
    Button,
    Tooltip,
    TranslocoPipe,
    AppDatePipe,
  ],
  templateUrl: './document-item.component.html',
})
export class DocumentItemComponent {
  private readonly directusService = inject(DirectusService);
  private readonly confirmDialogService = inject(ConfirmationDialogService);

  readonly document = input.required<InvitationUploadDocumentResponse>();
  readonly documentType = input.required<InvitationUploadDocumentTranslation[]>();
  readonly isEditable = input.required<boolean>();

  readonly previewItem = output<number>();
  readonly downloadItem = output<number>();
  readonly editItem = output<InvitationUploadDocumentResponse>();
  readonly deleteItem = output<number>();

  readonly uploadDocumentStatusOptions = toSignal(
    this.directusService.loadDirectusDropdown('rfq_invitation_upload_document_status'),
    {initialValue: []},
  );

  protected readonly documentStatus = computed<DirectusTranslation[]>(() => {
    const currentTypes = this.uploadDocumentStatusOptions();
    const currentDocument = this.document();

    if (!currentTypes || currentTypes.length < 1 || !currentDocument) {
      return [];
    }

    const foundDocumentType = currentTypes.find((x) => x.id === currentDocument.documentStatusUuid);
    return foundDocumentType ? foundDocumentType.translations : [];
  });

  protected onDelete(): void {
    this.confirmDialogService.confirm({
      headerKey: 'confirmationDialog.deleteItem.header',
      messageKey: 'confirmationDialog.deleteItem.text',
      accept: () => {
        this.deleteItem.emit(this.document().id);
      },
    });
  }
}
